import { css } from 'lit';
import { styles as baseStyles } from '@triptease/stylesheet/lit';

export const styles = [
  baseStyles,
  css`
    :host {
      display: block;
    }

    .paginator-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: var(--space-scale-2);
    }

    nav {
      display: flex;
      align-items: center;
      gap: var(--space-scale-1);
    }

    button {
      min-width: 2rem;
    }
  `,
];
